











































import {
  computed,
  defineComponent,
  onMounted,
  ref,
} from "@vue/composition-api";
import Store from "@/store";
import {
  GetProjectEmployerFilesTableRequest,
  ProjectDto,
  ProjectEmployerFilesApi,
  VueTableResponseOfProjectEmployerFilesTableDto,
} from "@/api";
import { downloadDocument } from "@/util/download";
import { toLocalDateTimeStringShort } from "@/util/date";
import bytesToSize from "@/util/file";
import { useMachine } from "@xstate/vue";
import { DataTableHeader, DataOptions } from "vuetify";
import i18n from "@/i18n";
import ProjectFilesMachine from "./ProjectFilesMachine";

export default defineComponent({
  name: "Files",
  components: {},
  setup(_, vm) {
    const projectEmployerFilesApi = new ProjectEmployerFilesApi();

    const { state, service } = useMachine(ProjectFilesMachine);

    const files = ref<VueTableResponseOfProjectEmployerFilesTableDto>({
      items: [],
      total: 0,
    });

    let options: DataOptions = {
      page: 1,
      itemsPerPage: 25,
      sortBy: ["uploadDate"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
    };

    const headers: DataTableHeader[] = [
      {
        text: i18n.t("project-files.fileName").toString(),
        value: "fileName",
      },
      {
        text: i18n.t("project-files.fileSize").toString(),
        value: "fileSize",
      },
      {
        text: i18n.t("project-files.uploadDate").toString(),
        value: "uploadDate",
      },
    ];

    const currentPage = ref(0);

    const selectedProject = computed<ProjectDto | null>(
      () => Store.getters["User/getSelectedProject"]
    );

    const projectId = computed(() => Number(selectedProject.value?.projectId));

    function updateOptions(opts: DataOptions) {
      options = opts;
      service.send("RELOAD");
    }

    async function getFiles(opts: DataOptions) {
      try {
        const request: GetProjectEmployerFilesTableRequest = {
          sortBy: opts.sortBy,
          descending: opts.sortDesc,
          page: opts.page,
          rowsPerPage: opts.itemsPerPage,
          projectId: projectId.value,
        };

        const {
          data,
        } = await projectEmployerFilesApi.projectEmployerFilesGetProjectEmployerFilesTable(
          request
        );

        const { total, items } = data;

        files.value.items = items;
        files.value.total = total;
        service.send("RESOLVE");
      } catch {
        service.send("REJECT");
      }
    }

    async function downloadFile(fileName: string | null | undefined) {
      if (!fileName) return;

      const {
        data,
        headers,
      } = await projectEmployerFilesApi.projectEmployerFilesDownloadProjectEmployerFile(
        projectId.value,
        fileName,
        {
          responseType: "arraybuffer",
        }
      );

      downloadDocument(data, headers, fileName);
    }

    async function handleDownload(fileName: string | null | undefined) {
      await downloadFile(fileName);
    }

    onMounted(() => {
      service.subscribe((s) => {
        if (s.matches("loading")) {
          getFiles(options);
        }
      });
    });

    return {
      files,
      handleDownload,
      bytesToSize,
      toLocalDateTimeStringShort,
      options,
      headers,
      currentPage,
      updateOptions,
      state,
    };
  },
});
